<script setup lang="ts">
const _props = defineProps<{
  title?: string
  subtitle?: string
  media?: MediaProps
  parent?: unknown
  theme?: string
  isEducation?: boolean
}>()

const { isMobileOrTablet } = useDevice()
const { width: innerWidth } = useWindowSize()

const isMobile = computed(() => {
  if (import.meta.server) return isMobileOrTablet
  return innerWidth.value < 900
})
</script>
<template>
  <div
    class="relative flex bg-(--theme-bg) text-(--theme-fg)"
    :class="['theme-' + theme, { 'lg:flex-row-reverse': isEducation }]"
  >
    <ElementsThemeSetter :theme="theme" :is-hero="true" />

    <div
      class="px-bleed absolute z-10 flex h-full w-full flex-col justify-end lg:relative lg:h-auto lg:w-1/2 lg:pb-10"
      :class="{ 'lg:px-(--grid-gap)': isEducation }"
    >
      <ElementsArrowLink :link="parent" variant="back" class="mb-7.5 lg:mb-10">{{
        parent.label
      }}</ElementsArrowLink>
      <h1
        class="font-display text-3xl leading-[0.65] lg:text-5xl"
        :class="{ 'lg:w-cols-5 lg:!leading-[1]': isEducation }"
      >
        <CommonExposedText
          v-if="isMobile && title"
          :text="title"
          :exposure="[-40, -80]"
          :animated="true"
        />
        <CommonProximityText
          v-else-if="title"
          :text="title"
          :radius="200"
          falloff="gaussian"
          :exposure="{ from: -20, to: -80 }"
        />
      </h1>
    </div>
    <div class="inset-0 aspect-[4/5] lg:aspect-4/3 lg:w-1/2">
      <CommonMedia
        v-if="media"
        :media="media"
        class="h-full w-full object-cover"
        :sizes="'xs:100vw sm:100vw md:100vw lg:50vw xl:50vw xxl:50vw'"
      />
    </div>
    <div class="overlay absolute top-0 left-0 z-[1] h-full w-full bg-black opacity-10" />
  </div>
</template>
